import { useCallback, useState } from 'react';

// #region Types
type Return = [
  boolean,
  {
    setIsOn: (value: boolean) => void;
    toggle: () => void;
    turnOff: () => void;
    turnOn: () => void;
  },
];
// #endregion

/**
 * Hooks for providing common handler of boolean state
 *
 * @param initialState
 */
export default function useBoolean(initialState = false): Return {
  // #region States
  const [isOn, setIsOn] = useState(initialState);
  // #endregion

  // #region Handlers
  const toggle = useCallback(() => setIsOn((prev) => !prev), []);
  const turnOn = useCallback(() => setIsOn(true), []);
  const turnOff = useCallback(() => setIsOn(false), []);
  // #endregion

  return [isOn, { setIsOn, toggle, turnOff, turnOn }];
}
